<template>
  <div
    class="feedback"
    v-observe-visibility="{
      callback: visibilityChanged,
      intersection: {
        threshold: 0.5,
      },
    }"
  >
    <div
      v-swiper:mySwiper="swiperOption"
      class="container swiper info-graph__swiper"
      :class="{ enter: isVisible, left: rollFronLeft }"
    >
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img
            :src="require(`../assets/feedback${feedback.imgGroupId}-1.jpg`)"
          />
        </div>
        <div class="swiper-slide">
          <img
            :src="require(`../assets/feedback${feedback.imgGroupId}-2.jpg`)"
          />
        </div>
        <div class="swiper-slide">
          <img
            :src="require(`../assets/feedback${feedback.imgGroupId}-3.jpg`)"
          />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="feedback__content">
      <div class="feedback__content--title">
        {{ feedback.name }}<span>{{ feedback.isMr ? " 先生" : " 小姐" }}</span>
        <div class="feedback__content--store">{{ feedback.store }}</div>
      </div>
      <div>
        <div
          class="feedback__content--desc"
          v-for="desc in feedback.desc"
          :key="desc"
        >
          {{ desc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper as SwiperClass, Autoplay, Pagination } from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
const { directive } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Autoplay, Pagination]);
export default {
  name: "FeedbackItem",
  directives: {
    swiper: directive,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  props: {
    feedback: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    swiperOption() {
      return {
        loop: true,
        spaceBetween: 0,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="' + ${className} + '" key=${index}></span>`;
          },
        },
      };
    },
    rollFronLeft() {
      return this.index % 2;
    },
  },
  methods: {
    visibilityChanged(isVisible) {
      this.isVisible = isVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  @media (min-width: 768px) {
    padding: 24px 0px;
  }

  &__content {
    padding: 28px 42px;
    @media (min-width: 768px) {
      display: flex;
      max-width: 977px;
      padding: 40px 0;
      align-items: center;
    }
    &--title {
      font-weight: 700;
      font-size: 24px;
      line-height: 35px;
      text-align: center;
      color: #009944;
      margin-bottom: 32px;
      @media (min-width: 768px) {
        font-size: 40px;
        line-height: 58px;
        margin-bottom: 0;
        min-width: 177px;
        margin-right: 44px;
        span {
          font-size: 24px;
        }
      }
    }
    &--desc {
      font-weight: 350;
      font-size: 16px;
      line-height: 24px;
      color: #009944;
      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 27px;
        flex: 1;
        &:not(:first-child) {
          margin-top: 16px;
        }
      }
    }
    &--store {
      font-weight: 400;
      font-size: 18px;
      line-height: 27px;
      @media (min-width: 768px) {
        font-size: 24px;
        line-height: 36px;
      }
    }
  }
}

.swiper {
  width: 100vw;
  height: 67vw;
  position: relative;
  overflow: hidden;
  transform: translate(50%);
  transition: transform 2s;
  background: #77bc1f;
  @media (min-width: 768px) {
    border: 6px solid #77bc1f;
    border-radius: 46px;
    // -webkit-transform: rotate(0deg);
    -webkit-mask-image: -webkit-radial-gradient(white, black);
    overflow: hidden;
    max-width: 977px;
    margin: 0 auto;
    height: auto;
    width: calc(100vw - 80px - 344px - 400px);
    position: relative;
    z-index: 0;
  }

  img {
    opacity: 0;
    transition: opacity 2s;
  }

  &.left {
    transform: translate(-50%);
    background: #ffff29;
  }

  &.enter {
    transform: translate(0);

    img {
      opacity: 1;
    }
  }
}

.swiper-wrapper {
  display: flex;
  width: 500%;
  position: relative;
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
}

.swiper-slide {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  img {
    width: 100%;
  }
}
.swiper-pagination::v-deep {
  position: absolute;
  bottom: 8px;
  height: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 8px;

  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    background: #d9d9d9;
    border-radius: 50%;

    & + .swiper-pagination-bullet {
      margin-left: 8px;
    }
  }

  .swiper-pagination-bullet-active {
    background: #ffed00;
  }
}
</style>
